'use strict';

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var _ = require('underscore');
/**
 * View builder for Toggle Switch or element to be toggled by global event.
 *
 * Usage:
 *
 *  data-sw-toggle="<selector to toggle or blank if this will be toggled by global event>"
 *
 *  data-sw-toggle-prevent-default="false"
 *
 *  data-sw-toggle-class="<custom class to turn on and off>" //if not specified toggling will hide and show target element
 *
 *  data-sw-toggle-direction="<add or remove>" //makes switch only go one direction
 *
 *  data-sw-toggle-el-event="<el event to listen for to trigger toggle>"
 *
 *  data-sw-toggle-el-event-add="<el event that triggers a toggle only in the add direction>"
 *
 *  data-sw-toggle-el-event-remove="<el event that triggers a toggle only in the remove direction>"
 *
 *  data-sw-toggle-global-event="<global event to listen for to trigger toggle>"
 *
 *  data-sw-toggle-global-event-add="<global event that triggers a toggle only in the add direction>"
 *
 *  data-sw-toggle-global-event-remove="<global event that triggers a toggle only in the remove direction>"
 *
 *  data-sw-toggle-targets-<target namespace>-classes="<classes to add, remove, or toggle on an additional element>"
 *
 *  data-sw-toggle-targets-<target namespace>-selector="<selector for additional element>"
 *
 *  data-sw-toggle-addl-<target namespace>-el-event="<additional event to trigger for namespace>"
 *
 *  data-sw-toggle-addl-<target namespace>-direction="<add | remove>" Make the switch one direction for namespace
 *
 *  data-sw-toggle-addl-<target namespace>-el-event-add="<el event that triggers in the namespace a toggle only in the add direction>"
 *
 *  data-sw-toggle-addl-<target namespace>-el-event-remove="<el event that triggers in the namespace a toggle only in the remove direction>"
 *
 *  data-sw-toggle-addl-<target namespace>-classes="<classes to add, remove, or toggle on an the namespaced additional event>"
 *
 *  data-sw-toggle-addl-<target namespace>-selector="<selector for namespaced additional event>"
 *
 *  data-sw-toggle-el-remove="<element that toggles in the remove direction>"
 *      useful when set on the body to close dropdown menus
 *
 *  data-sw-toggle-is-toggler="<true|false>"
 *
 *  Note: <target namespace> cannot contain any dashes.
 *    ex. "data-sw-toggle-targets-look-im-dashed-classes" will not work.
 */

var MODULE_ATTR = 'data-sw-toggle';
var DIRECTION_ATTR = 'data-sw-toggle-direction';
var CLASS_ATTR = 'data-sw-toggle-class';
var EL_EVENT = 'data-sw-toggle-el-event';
var EL_EVENT_ADD = 'data-sw-toggle-el-event-add';
var EL_EVENT_REMOVE = 'data-sw-toggle-el-event-remove';
var GLOBAL_EVENT = 'data-sw-toggle-global-event';
var GLOBAL_EVENT_ADD = 'data-sw-toggle-global-event-add';
var GLOBAL_EVENT_REMOVE = 'data-sw-toggle-global-event-remove';
var IS_TOGGLER = 'data-sw-toggle-is-toggler';
var PREVENT_DEFAULT = 'data-sw-toggle-prevent-default';
var EL_REMOVE_ON_OUTSIDE_CLICK = 'data-sw-toggle-remove-on-outside-click';
var ADD_DIRECTION = 'add';
var REMOVE_DIRECTION = 'remove';
var TOGGLE_CLASS = 'sw--is-hidden';

var camelCaseRegex = /([A-Z]?[^A-Z]*)/g;

/**
 * Handles add, remove, or toggle given a target and/or options with target information.
 * @param $target
 * @param options
 */
function handleToggle($target, options) {
  options = options || {};

  var toggleClass = options.toggleClass ? options.toggleClass : ($target && $target.attr(CLASS_ATTR) || TOGGLE_CLASS);
  var toggleSelector = options.toggleSelector ? options.toggleSelector : ($target && $target.attr(MODULE_ATTR) || '');
  var direction = options.direction ? options.direction : ($target && $target.attr(DIRECTION_ATTR) || '');

  var $toggleEl = toggleSelector === '' ? $target : $(toggleSelector);

  var closeOnOutsideClick = $target.attr(EL_REMOVE_ON_OUTSIDE_CLICK);
  var clickEvent = 'click.swToggle' + '_' + Math.random().toString(36).substr(2, 9);
  var closeHandler = function (e) {
    if (!$(toggleSelector).swFindWithSelf(e.target).length) {
      $toggleEl.removeClass(toggleClass);
      $('body').off(clickEvent);
    }
  };

  if(direction && (direction === ADD_DIRECTION)) {
    $toggleEl.addClass(toggleClass);

    if (closeOnOutsideClick) {
      $('body').on(clickEvent, closeHandler);
    }

  } else if(direction && (direction === REMOVE_DIRECTION)) {
    $toggleEl.removeClass(toggleClass);
  } else {
    if (!$toggleEl.hasClass(toggleClass) && closeOnOutsideClick) {
      if (closeOnOutsideClick) {
        $('body').on(clickEvent, closeHandler);
      }
    }

    $toggleEl.toggleClass(toggleClass);
  }
}

/**
 *
 * @param targetDataPrams data params for additional target info
 * return object a target map ({namespace: {classes: <string>, selector: <string>}})
 */
function getTargetMap(targetDataPrams) {
  return _.reduce(targetDataPrams, function (targetMap, attrVal, attrName) {
    var targetInfo = attrName.replace('swToggleTargets', '');
    var info, targetKey, targetProp;

    if(!_.isEmpty(attrVal)) {
      info = targetInfo.match(camelCaseRegex);
      if(info.length >= 2) {

        // key for the target prop ('body' in data-sw-toggle-target-body-classes')
        targetKey = info[0].toLowerCase();

        // key for the target prop ('classes' in data-sw-toggle-target-body-classes')
        targetProp = info[1].toLowerCase();

        targetMap[targetKey] = !_.isEmpty(targetMap[targetKey]) ? targetMap[targetKey] : {};
        targetMap[targetKey][targetProp] = attrVal;
      }
    }

    return targetMap;
  }, {});
}

/**
 *
 * @param targetDataParams data params for additional target info
 * return object a target map ({namespace: {classes: <string>, selector: <string>}})
 */
function getTriggerMap(targetDataParams) {
  return _.reduce(targetDataParams, function (targetMap, attrVal, attrName) {
    var targetInfo = attrName.replace('swToggleAddl', '');
    var info, targetKey, targetPropRaw, targetProp;

    if(!_.isEmpty(attrVal)) {
      info = targetInfo.match(camelCaseRegex);
      if(info.length >= 2) {

        // key for the target prop ('body' in data-sw-toggle-target-body-classes')
        targetKey = info[0].toLowerCase();

        // key for the target prop ('classes' in data-sw-toggle-target-body-classes')
        targetPropRaw = info.slice(1).join("");
        targetProp = targetPropRaw.charAt(0).toLowerCase() + targetPropRaw.slice(1);

        targetMap[targetKey] = !_.isEmpty(targetMap[targetKey]) ? targetMap[targetKey] : {};
        targetMap[targetKey][targetProp] = attrVal;
      }
    }

    return targetMap;
  }, {});
}


/**
 * Takes an object of namespaced target information and handles the toggle for each.
 * @param targets
 * @param options
 */
function toggleAdditionalTargets(targets, options) {
  options = options || {};
  if (!_.isEmpty(targets)) {
    _.each(targets, function(target) {
      handleToggle(null, {
        toggleClass: target.classes,
        toggleSelector: target.selector,
        direction: options.direction
      });
    });
  }
}

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-toggle]').each(function() {
    var $el = $(this);

    var elEvent = $el.attr(EL_EVENT);
    var elEventAdd = $el.attr(EL_EVENT_ADD);
    var elEventRemove = $el.attr(EL_EVENT_REMOVE);
    var globalEvent = $el.attr(GLOBAL_EVENT);
    var globalEventAdd = $el.attr(GLOBAL_EVENT_ADD);
    var globalEventRemove = $el.attr(GLOBAL_EVENT_REMOVE);

    var isToggler;
    if ($el[0].hasAttribute(IS_TOGGLER)) {
      isToggler = $el.attr(IS_TOGGLER);
    } else {
      isToggler = !(globalEvent || globalEventAdd || globalEventRemove);
    }

    var preventDefault = false;
    if ($el[0].hasAttribute(PREVENT_DEFAULT)) {
      preventDefault = $el.attr(PREVENT_DEFAULT);
    }


    var direction = $el.attr(DIRECTION_ATTR);

    // Lets you target multiple targets with a namespace
    var additionalTargetsDataParams = $el.swDataParams('swToggleTargets');
    var targets = getTargetMap(additionalTargetsDataParams);

    // Lets you do additional triggers on same element with a namespace
    var additionalTriggerDataParams = $el.swDataParams('swToggleAddl');
    var additionalTriggers = getTriggerMap(additionalTriggerDataParams);

    // default to click if not explicitly set
    elEvent = !(elEvent || elEventAdd || elEventRemove) ? 'click' : elEvent;

    var functions = {
      toggle: function toggle(event) {
        handleToggle($el);
        toggleAdditionalTargets(targets, {direction: direction});

        if (event && preventDefault) {
          event.preventDefault();
        }
      },

      add: function add(event) {
        handleToggle($el, {direction: ADD_DIRECTION});
        toggleAdditionalTargets(targets, {direction: ADD_DIRECTION});

        if (event && preventDefault) {
          event.preventDefault();
        }
      },

      remove: function remove(event) {
        handleToggle($el, {direction: REMOVE_DIRECTION});
        toggleAdditionalTargets(targets, {direction: REMOVE_DIRECTION});

        if (event && preventDefault) {
          event.preventDefault();
        }
      }
    };

    function registerAll(listener, eventToggle, eventAdd, eventRemove, functions) {
      if (eventToggle) {
        listener.on(eventToggle, functions.toggle);
      }

      if (eventAdd) {
        listener.on(eventAdd, functions.add);
      }

      if (eventRemove) {
        listener.on(eventRemove, functions.remove);
      }
    }

    //is this element acting as a toggle switch or is it an item toggled by global event
    if(isToggler) {
      registerAll($el, elEvent, elEventAdd, elEventRemove, functions);
      registerAll(sw, globalEvent, globalEventAdd, globalEventRemove, functions);
    } else {
      registerAll(sw, globalEvent, globalEventAdd, globalEventRemove, functions);
    }

    _.each(additionalTriggers, function(event) {
      var functions = {
        toggle: function toggle() {
          handleToggle($el, {
            toggleClass: event.classes,
            toggleSelector: event.selector,
            direction: event.direction
          });
        },

        add: function add() {
          handleToggle($el, {
            toggleClass: event.classes,
            toggleSelector: event.selector,
            direction: ADD_DIRECTION
          });
        },

        remove: function remove() {
          handleToggle($el, {
            toggleClass: event.classes,
            toggleSelector: event.selector,
            direction: REMOVE_DIRECTION
          });
        }
      };

      var elEvent = event.elEvent;
      elEvent = !(elEvent || elEventAdd || elEventRemove) ? 'click' : elEvent;
      registerAll($el, elEvent, event.elEventAdd, event.elEventRemove, functions);
    });
  });

};
